@if (formCtrl().errors?.['min'] && (formCtrl().dirty || formCtrl().touched)) {
  <small class="error-info text-error">
    {{ errorMsg }}
  </small>
}
